module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/payment-card/cartes-bancaires-payment-card-fd769719b6e2e07accf5f1b556d48bac.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/payment-card/cartes-bancaires-payment-card.svg
// module id = ImIG
// module chunks = 24